// this monkey patches the trix editor to open links in a new tab
// In their github repository, they closed multiple issues about this
// and this was one of the solutions
document.addEventListener("turbolinks:load", function() {
  document.querySelectorAll(".trix-content a").forEach(function(link) {
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "nofollow");
  });
})